import { useEffect } from 'react';
import { capitalizeFirstLetter } from '@la/utilities';
import { ConsolidatedCheckoutProvider } from 'lib/context/ConsolidatedCheckoutContext/ConsolidatedCheckoutContext';
import { getSiteIdentityData } from 'redux/coreSlice';
import { useGetUserIdQuery } from 'redux/services/userInfo';
import { useAppSelector } from 'redux/store';
import PageTitle from 'domains/Shell/PageTitle/PageTitle';
import CheckoutPageContent from './CheckoutPageContent/CheckoutPageContent';
import ConfirmationPageContent from './ConfirmationPageContent/ConfirmationPageContent';
import * as S from './Checkout.styles';

/* Checkout */
export default function ConsolidatedCheckout({
  pageName = 'checkout',
}: Readonly<{
  pageName: string;
}>) {
  const { siteId, siteName } = useAppSelector(getSiteIdentityData);
  const { data: userId } = useGetUserIdQuery(siteId);

  const pageNameInTitleCase = capitalizeFirstLetter(pageName);

  useEffect(() => {
    document.title = siteName
      ? `${siteName}: ${pageNameInTitleCase}`
      : `${pageNameInTitleCase}`;
  }, [pageNameInTitleCase, siteName]);

  function getPageContent() {
    return pageName === 'checkout' ? (
      <S.Checkout id="checkout-page">
        <PageTitle>Checkout</PageTitle>
        <CheckoutPageContent siteId={siteId} userId={userId} />
      </S.Checkout>
    ) : (
      <S.Checkout id="confirmation-page">
        <PageTitle>Thank you</PageTitle>
        <ConfirmationPageContent siteId={siteId} />
      </S.Checkout>
    );
  }

  return (
    <ConsolidatedCheckoutProvider>
      {getPageContent()}
    </ConsolidatedCheckoutProvider>
  );
}
/* */
